import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { withRouter } from 'react-router-dom'

import Loading from '../../Common/Loading/Loading'
import SelectBox from '../../Common/SelectBox2'
import { DMM_API_HOST, DMM_API_KEY } from '../../../_Components/Common/common'

const assistantCreate = props => {
  const { data } = props.location.state

  const [assistantId, setAssistantId] = useState(data ? data.assistantId : '')
  const [assistantName, setAssistantName] = useState(
    data ? data.assistantName : ''
  )
  const [instructions, setInstructions] = useState(
    data ? data.instructions : ''
  )
  const [model, setModel] = useState(data ? data.region : '')
  const [models, setModels] = useState(props.location.state.models)
  const [toolsList, setToolsList] = useState(['file_search'])
  const [artistId, setArtistId] = useState(data ? data.artistId : '')
  const [mainColor, setMainColor] = useState(data ? data.mainColor : '')
  const [subColor, setSubColor] = useState(data ? data.subColor : '')
  const [lineColor, setLineColor] = useState(data ? data.lineColor : '')
  const [intro, setIntro] = useState(data ? data.intro : '')
  const [category, setCategory] = useState(data ? data.category : '')
  const [profileImg, setProfile] = useState(null)
  const [assistantImg, setAssistantImg] = useState(null)
  const [profileImgUrl, setProfileImgUrl] = useState(
    data ? data.profileImg : ''
  )
  const [assistantImgUrl, setAssistantImgUrl] = useState(
    data ? data.assistantImg : ''
  )
  const [createUser, setCreateUser] = useState(
    data ? data.createUserEmail : 'ps7izuko@luravel.com'
  )
  const [status, setStatus] = useState(data ? data.assistantStatus : 'Y')
  const [gender, setGender] = useState(data ? data.gender : '')
  const [freeStart, setFreeStart] = useState(
    data ? (data.freeStartDate ? data.freeStartDate.slice(0, 10) : '') : ''
  )
  const [freeEnd, setFreeEnd] = useState(
    data ? (data.freeEndDate ? data.freeEndDate.slice(0, 10) : '') : ''
  )
  const [speechType, setSpeechType] = useState(data ? data.speechType : '')
  const [age, setAge] = useState(data ? data.age : '')
  const [birth, setBirth] = useState(data ? data.birth : '')
  const [height, setHeight] = useState(data ? data.height : '')
  const [weight, setWeight] = useState(data ? data.weight : '')
  const [mbti, setMbti] = useState(data ? data.mbti : '')
  const [pov, setPov] = useState(data ? data.pov : '')
  const [marketing, setMarketing] = useState(data ? data.marketing : 'N')

  const emailList = [
    'ps7izuko@luravel.com',
    'wbkita@luravel.com',
    'lydia3601@luravel.com',
    'aolst@luravel.com',
    'totomkio@luravel.com',
    'sasaki7@luravel.com',
    'j.jun@luravel.com',
    'narunaru@luravel.com',
    'tonyk@luravel.com',
    'kyu451@luravel.com',
    'kzhiro@luravel.com',
    'shokujm@luravel.com',
    'gibaba@luravel.com',
    'sansour@luravel.com',
    'kxwxsto@luravel.com',
    'hiro62@luravel.com',
    'jjmh3@luravel.com',
    'danshoto@luravel.com',
    'kkhnn@luravel.com',
    'baktam0072@luravel.com',
  ]

  const statusList = ['Y', 'U', 'P']
  const speechTypeList = ['informal', 'honorific']
  const genderList = ['male', 'female']
  const mbtiList = [
    'INFJ',
    'INFP',
    'INTJ',
    'INTP',
    'ISFJ',
    'ISFP',
    'ISTJ',
    'ISTP',
    'ENFJ',
    'ENFP',
    'ENTJ',
    'ENTP',
    'ESFJ',
    'ESFP',
    'ESTJ',
    'ESTP',
  ]
  const marketingList = ['Y', 'N']

  const onChange = model => {
    setModel(model)
  }

  const freeValue = useMemo(() => {
    const isValidDateFormat = dateStr =>
      typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)

    const today = new Date().toISOString().slice(0, 10)

    const hasStart = isValidDateFormat(freeStart)
    const hasEnd = isValidDateFormat(freeEnd)

    if (!hasStart) {
      if (!hasEnd) return 'N'
      return freeEnd >= today ? 'Y' : 'N'
    }

    if (!hasEnd) {
      return freeStart <= today ? 'Y' : 'N'
    }

    return freeEnd >= today ? 'Y' : 'N'
  }, [freeStart, freeEnd])

  const dateValid = d => {
    const NotNum = /[^0-9]/g
    const onlyNum = d.replace(NotNum, '')

    let format
    let validFormat

    if (onlyNum.length === 6) {
      if (Number(onlyNum.slice(4, 6)) > 12 || Number(onlyNum.slice(4, 6)) < 1) {
        return
      }
    }

    if (onlyNum.length === 8) {
      if (Number(onlyNum.slice(6, 8)) > 31 || Number(onlyNum.slice(6, 8)) < 1) {
        return
      }
    }

    if (onlyNum.length >= 9) {
      return
    }

    if (onlyNum.length <= 6) {
      format = '$1-$2'
      validFormat = /([0-9]{4})([0-9]+)/
    } else if (onlyNum.length <= 8) {
      format = '$1-$2-$3'
      validFormat = /([0-9]{4})([0-9]{2})([0-9]+)/
    }

    const newDate = onlyNum.replace(validFormat, format)

    setBirth(newDate)
  }

  const save = async () => {
    const formData = new FormData()

    formData.append('assistantName', assistantName)
    formData.append('instructions', instructions)
    formData.append('model', model)
    formData.append('toolsList', toolsList)
    formData.append('artistId', artistId)
    formData.append('mainColor', mainColor)
    formData.append('subColor', subColor)
    formData.append('lineColor', lineColor)
    formData.append('intro', intro)
    formData.append('category', category)
    formData.append('profileImg', profileImg)
    formData.append('assistantImg', assistantImg)
    formData.append('email', createUser)
    formData.append('status', status)
    formData.append('gender', gender)
    formData.append('freeStartDate', freeStart)
    formData.append('freeEndDate', freeEnd)
    formData.append('speechType', speechType)
    formData.append('age', age)
    formData.append('birth', birth)
    formData.append('height', height)
    formData.append('weight', weight)
    formData.append('mbti', mbti)
    formData.append('pov', pov)
    formData.append('marketing', marketing)

    const response = await fetch(`${DMM_API_HOST}/v4.0.1/assistant?admin=Y`, {
      headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        token: sessionStorage.getItem('token'),
        apikey: DMM_API_KEY,
      },
      method: 'post',
      body: formData,
    })

    const responseJson = await response.json()

    if (responseJson.header.status === 'success') {
      alert('success')
      props.history.push('/dmm/assistant')
    } else {
      alert('fail')
    }
  }

  const update = async () => {
    const formData = new FormData()

    formData.append('assistantName', assistantName)
    formData.append('instructions', instructions)
    formData.append('model', model)
    formData.append('toolsList', toolsList)
    formData.append('artistId', artistId)
    formData.append('mainColor', mainColor)
    formData.append('subColor', subColor)
    formData.append('lineColor', lineColor)
    formData.append('intro', intro)
    formData.append('category', category)
    formData.append('profileImg', profileImg)
    formData.append('assistantImg', assistantImg)
    formData.append('email', createUser)
    formData.append('status', status)
    formData.append('gender', gender)
    formData.append('freeStartDate', freeStart)
    formData.append('freeEndDate', freeEnd)
    formData.append('speechType', speechType)
    formData.append('age', age)
    formData.append('birth', birth)
    formData.append('height', height)
    formData.append('weight', weight)
    formData.append('mbti', mbti)
    formData.append('pov', pov)
    formData.append('marketing', marketing)

    const response = await fetch(
      `${DMM_API_HOST}/v4.0.1/assistant/${assistantId}?admin=Y`,
      {
        headers: {
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
          token: sessionStorage.getItem('token'),
          apikey: DMM_API_KEY
        },
        method: 'put',
        body: formData,
      }
    )

    const responseJson = await response.json()

    if (responseJson.header.status === 'success') {
      alert('success')
      props.history.push('/dmm/assistant')
    } else {
      alert('fail')
    }
  }

  const [Select, setState] = SelectBox(model, models, onChange)

  return (
    <>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        assistantName:{' '}
        <input
          type={'text'}
          style={{ width: 300 }}
          value={assistantName}
          onChange={e => setAssistantName(e.target.value)}
        />
      </div>

      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        Instructions:
        <div>
          <textarea
            type={'text'}
            style={{ width: 500, height: 300 }}
            value={instructions}
            onChange={e => setInstructions(e.target.value)}
          />
        </div>
      </div>

      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        {!data && Select}
      </div>

      <div style={{ textAlign: 'left', marginBottom: '10px', display: 'flex' }}>
        free : <div style={{ marginRight: '20px' }}>{freeValue}</div>
        start:{' '}
        <input
          type={'text'}
          style={{ width: 150, marginRight: '20px' }}
          value={freeStart ? freeStart.slice(0, 10) : ''}
          onChange={e => setFreeStart(e.target.value.slice(0, 10))}
        />
        end:{' '}
        <input
          type={'text'}
          style={{ width: 150 }}
          value={freeEnd ? freeEnd.slice(0, 10) : ''}
          onChange={e => setFreeEnd(e.target.value.slice(0, 10))}
        />
      </div>

      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        status:{' '}
        <select value={status} onChange={e => setStatus(e.target.value)}>
          {statusList.map((s, i) => (
            <option key={i} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>

      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        create user:{' '}
        <select
          value={createUser}
          onChange={e => setCreateUser(e.target.value)}
        >
          {createUser && emailList.indexOf(createUser) < 0 ? (
            <option value={createUser}>{createUser}</option>
          ) : (
            emailList.map((email, index) => (
              <option key={index} value={email}>
                {email}
              </option>
            ))
          )}
        </select>
      </div>

      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        artistId:{' '}
        <input
          type={'text'}
          style={{ width: 300 }}
          value={artistId}
          onChange={e => setArtistId(e.target.value)}
        />
      </div>

      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        mainColor:{' '}
        <input
          type={'text'}
          style={{ width: 300 }}
          value={mainColor}
          onChange={e => setMainColor(e.target.value)}
        />
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        subColor:{' '}
        <input
          type={'text'}
          style={{ width: 300 }}
          value={subColor}
          onChange={e => setSubColor(e.target.value)}
        />
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        lineColor:{' '}
        <input
          type={'text'}
          style={{ width: 300 }}
          value={lineColor}
          onChange={e => setLineColor(e.target.value)}
        />
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        intro:{' '}
        <input
          type={'text'}
          style={{ width: 300 }}
          value={intro}
          onChange={e => setIntro(e.target.value)}
        />
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        category:{' '}
        <input
          type={'text'}
          style={{ width: 300 }}
          value={category}
          onChange={e => setCategory(e.target.value)}
        />
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        gender:
        <select value={gender} onChange={e => setGender(e.target.value)}>
          <option value="">선택해주세요</option>
          {genderList.map((g, i) => (
            <option key={i} value={g}>
              {g}
            </option>
          ))}
        </select>
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        profileImg:{' '}
        <input
          type="file"
          style={{ width: '50%' }}
          onChange={event => {
            const file = event.target.files[0]
            const reader = new FileReader()

            reader.onloadend = () => {
              setProfileImgUrl(reader.result)
              setProfile(file)
            }
            if (file) {
              reader.readAsDataURL(file)
            }
          }}
        />
        {profileImgUrl && <img src={profileImgUrl} style={{ width: 100 }} />}
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        assistantImg:{' '}
        <input
          type="file"
          style={{ width: '50%' }}
          onChange={event => {
            const file = event.target.files[0]
            const reader = new FileReader()

            reader.onloadend = () => {
              setAssistantImgUrl(reader.result)
              setAssistantImg(file)
            }
            if (file) {
              reader.readAsDataURL(file)
            }
          }}
        />
        {assistantImgUrl && (
          <img src={assistantImgUrl} style={{ width: 300 }} />
        )}
      </div>
      <div>추가정보</div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        speechType:
        <select
          value={speechType}
          onChange={e => setSpeechType(e.target.value)}
        >
          <option value="">선택해주세요</option>
          {speechTypeList.map((s, i) => (
            <option key={i} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        age:
        <input
          type={'text'}
          style={{ width: 300 }}
          value={age}
          onChange={e => setAge(e.target.value)}
        />
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        birth:
        <input
          type={'text'}
          style={{ width: 300 }}
          value={birth}
          onChange={e => dateValid(e.target.value)}
        />
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        height:
        <input
          type={'text'}
          style={{ width: 300 }}
          value={height}
          onChange={e => setHeight(e.target.value)}
        />
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        weight:
        <input
          type={'text'}
          style={{ width: 300 }}
          value={weight}
          onChange={e => setWeight(e.target.value)}
        />
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        MBTI:
        <select value={mbti} onChange={e => setMbti(e.target.value)}>
          <option value="">선택해주세요</option>
          {mbtiList.map((m, i) => (
            <option key={i} value={m}>
              {m}
            </option>
          ))}
        </select>
      </div>
      <div style={{ textAlign: 'left', marginBottom: '10px' }}>
        마케팅 여부:
        <select value={marketing} onChange={e => setMarketing(e.target.value)}>
          {marketingList.map((s, i) => (
            <option key={i} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      <div style={{ textAlign: 'left', marginBottom: '40px' }}>
        일본어 전용 1인칭:
        <input
          type={'text'}
          style={{ width: 300 }}
          value={pov}
          onChange={e => setPov(e.target.value)}
        />
      </div>
      <div style={{ textAlign: 'left', marginBottom: '40px' }}>
        <button onClick={data ? update : save}>{data ? '수정' : '저장'}</button>
      </div>
    </>
  )
}

export default withRouter(assistantCreate)
